import React from 'react';

const Loading = ({color , height , text}) => {

    let mainHeight = "300px";
    if(height) mainHeight = height;

    let mainText = true;
    if(text === false) mainText = false;

    return (

        <>

            <div className={`d-flex flex-column justify-content-center align-items-center m-4 `} style={{ height: mainHeight , color : `${color}` }}>
                <div className="spinner-border" role="status">

                </div>
                {mainText ? <div className='mt-2' style={{ fontSize: "0.8rem", userSelect: "none" }}>دریافت اطلاعات</div> : <></>}
            </div>

        </>
    );
};

export default Loading;